import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { StatsFilterUpdaterComponent } from './stats-filter-updater/stats-filter-updater.component';
import { StatsFiltersComponent } from './stats-filters.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        StatsFiltersComponent,
        StatsFilterUpdaterComponent
    ],
    exports: [
        StatsFiltersComponent
    ]
})
export class StatsFiltersModule { }
